module.exports = __webpack_public_path__ + "img/riskIndicatorIcon.f0215646.png";